module.exports = __webpack_public_path__ + "static/img/bonus_5.c30d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/bonus_5.png
// module id = n0Fy
// module chunks = 0